export default __webpack_public_path__ + "static/media/slide2_title.1ba2a534.png";